export function hasRecaptchaSiteKey() {
    return Boolean(process.env.VUE_APP_RECAPTCHA_SITE_KEY);
}

export async function getRecaptchaToken(vm, action) {
    if (!hasRecaptchaSiteKey() || typeof vm?.$recaptchaLoaded !== 'function') {
        return null;
    }

    try {
        await vm.$recaptchaLoaded();
        if (typeof vm.$recaptcha !== 'function') {
            return null;
        }
        const token = await vm.$recaptcha(action);
        return token || null;
    } catch (error) {
        return null;
    }
}
